import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from "@mui/material";
import React, {useState} from "react";
import MenuApi from "../../../api/menuApi/menuApi";
import {useFullMenu} from "../../../hooks/queries/useLogbookQueries";
import {useMutation, useQueryClient} from "@tanstack/react-query";

const UrunlerTable = () => {
    const queryClient = useQueryClient();
    const {data: urunler, isLoading} = useFullMenu();
    const [seciliUrun, setSeciliUrun] = useState<any>();
    const [expanded, setExpanded] = useState<string | false>(false);

    const mutation = useMutation({
        mutationFn: (pk: number) => MenuApi.updateUrunMevcut(pk),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['fullMenu']});
        }
    });

    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleUrunMevcutGuncelle = (urunPara?: any) => {
        const targetUrun = urunPara || seciliUrun;
        if (!targetUrun) return;

        mutation.mutate(targetUrun.id);
        if (seciliUrun && seciliUrun.id === targetUrun.id) {
            setSeciliUrun({...seciliUrun, mevcut: !seciliUrun.mevcut});
        }
    }

    if (isLoading) {
        return (
            <Box sx={{display: 'flex', justifyContent: 'center', p: 5}}>
                <CircularProgress/>
            </Box>
        );
    }

    return <Grid container spacing={2}>
        {seciliUrun && <Dialog
            open={true}
            onClose={() => setSeciliUrun(undefined)}
            maxWidth={"md"}
            PaperProps={{
                sx: {minWidth: "50%"}
            }}
        >
            <DialogTitle>
                <Typography variant="h5">
                    {seciliUrun.isim} - Hazırlanış
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sx={{m: 2}}>
                        <TextField
                            fullWidth
                            label={"Hazırlanış / Tarif"}
                            value={seciliUrun.tarif}
                            multiline
                            maxRows={10}
                            disabled
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{px: 3, pb: 2}}>
                <Button variant="outlined" color="secondary" onClick={() => setSeciliUrun(undefined)}>Kapat</Button>
            </DialogActions>
        </Dialog>}
        {
            urunler && urunler.map((kategori: any) => {
                return (
                    <Grid item xs={12} key={kategori.isim}>
                        <Accordion
                            sx={{width: "100%"}}
                            expanded={expanded === kategori.isim}
                            onChange={handleChange(kategori.isim)}
                        >
                            <AccordionSummary>
                                <Typography variant={"h5"}>
                                    {kategori.isim}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {kategori.sayfalar && kategori.sayfalar.map((sayfa: any) => {
                                    return (
                                        <Accordion sx={{width: "100%", backgroundColor: "white"}} key={sayfa.isim}>
                                            <AccordionSummary>
                                                <Typography variant={"h5"}>
                                                    {sayfa.isim}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <TableContainer component={Paper}>
                                                    <Table size={"small"}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center">Ürün Adı</TableCell>
                                                                <TableCell
                                                                    align="right">{sayfa.fiyat1 ?? "Fiyat"}</TableCell>
                                                                {sayfa.fiyat2 &&
                                                                    <TableCell align="right">{sayfa.fiyat2}</TableCell>}
                                                                <TableCell align="center">Mevcut</TableCell>
                                                                <TableCell align="center">İşlemler</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {sayfa.urunler.map((urun: any) => (
                                                                <TableRow
                                                                    key={sayfa.isim + "-" + urun.id}
                                                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                                                >
                                                                    <TableCell component="th" scope="urun">
                                                                        {urun.isim}
                                                                    </TableCell>
                                                                    <TableCell align="right">{urun.fiyat}</TableCell>
                                                                    {sayfa.fiyat2 &&
                                                                        <TableCell
                                                                            align="right">{urun.fiyat_2 == 0 ? "" : urun.fiyat_2}</TableCell>}
                                                                    <TableCell align="center">
                                                                        <Switch
                                                                            checked={urun.mevcut}
                                                                            onChange={() => handleUrunMevcutGuncelle(urun)}
                                                                            color="primary"
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        <Button
                                                                            variant="outlined"
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => setSeciliUrun(urun)}>
                                                                            Hazırlanış
                                                                        </Button>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>

                                        </Accordion>
                                    )
                                })}

                            </AccordionDetails>

                        </Accordion>
                    </Grid>)
            })
        }


    </Grid>;
}

export default UrunlerTable;
